const menuBuilderStore = {
  debug: true,

  state: {
    coffees: [],
    selectedCoffees: [],
    teas: [],
    customCoffees: [],
    extras: [],
    extrasTitle: {
      value: "Extras",
    },
    otherTitle: {
      value: "Other",
    },
    others: [],
    hasCertifications: {
      value: true,
    },
    logo: {
      data: "",
      width: 0,
      height: 0,
      ratio: 0,
    },
    formData: {
      fullName: "",
      email: "",
      companyName: "",
      postCode: "",
      newsletter: false,
      terms: false,
    },
    formErrors: {
      fullName: "",
      email: "",
      companyName: "",
      postCode: "",
      terms: "",
    },
    texts: {
      organic: "",
      fairtrade: "",
      rainforest: "",
      ourCoffees: "",
      certificationText: "",
    },
    hideOneSizeColumn: {
      value: false,
    },
    newProductPrice: {
      value: "",
    },
    extrasHelpText: {
      value: 'Click title to edit',
    },
    otherHelpText: {
      value: 'Click title to edit',
    },
  },

  setExtrasDefaultTitle(text) {
    this.state.extrasTitle.value = text
  },

  setExtrasHelpText(text) {
    this.state.extrasHelpText.value = text
  },

  setOtherHelpText(text) {
    this.state.otherHelpText.value = text
  },

  setOtherDefaultTitle(text) {
    this.state.otherTitle.value = text
  },

  setHideOneSizeColumn(value) {
    this.state.hideOneSizeColumn.value = value
  },

  setNewProductPrice(price) {
    this.state.newProductPrice.value = price
  },

  setTexts(organic, fairtrade, rainforest, ourCoffees, certification) {
    this.state.texts.organic = organic
    this.state.texts.fairtrade = fairtrade
    this.state.texts.rainforest = rainforest
    this.state.texts.ourCoffees = ourCoffees
    this.state.texts.certificationText = certification
  },

  setLogo (logo) {
    this.state.logo.data = logo
  },
  setLogoDimensions(height, width) {
    this.state.logo.width = width
    this.state.logo.height = height
    this.state.logo.ratio = width / height
  },
  setCoffees (coffees) {
    this.state.coffees.splice(0, this.state.coffees.length)
    this.state.coffees.push(...coffees)
  },

  addSelectedCoffee(coffee) {
    if(this.state.selectedCoffees.length < 2) {
      this.state.selectedCoffees.push(coffee)
    }
  },

  removeSelectedCoffee(coffee) {
    const index = this.state.selectedCoffees.indexOf(coffee);
    this.state.selectedCoffees.splice(index, 1)
  },

  addTea(name, price, description) {
    this.state.teas.push({name, price, description})
  },

  removeTea(tea) {
    const index = this.state.teas.indexOf(tea);
    this.state.teas.splice(index, 1)
  },

  addCustomCoffee(name, oneSize, s, m, l, certifications) {
    this.state.customCoffees.push({name, oneSize, s, m, l, certifications})
  },

  removeCustomCoffee(coffee) {
    const index = this.state.customCoffees.indexOf(coffee);
    this.state.customCoffees.splice(index, 1)
  },

  addExtra(name, price) {
    this.state.extras.push({name, price})
  },

  removeExtra(extra) {
    const index = this.state.extras.indexOf(extra);
    this.state.extras.splice(index, 1)
  },

  addOther(name, price, description) {
    this.state.others.push({name, price, description})
  },

  removeOther(other) {
    const index = this.state.others.indexOf(other);
    this.state.others.splice(index, 1)
  },

}

export default menuBuilderStore;



// WEBPACK FOOTER //
// ./scripts/vue/stores/menubuilder.store.js